import React, { useEffect, useState } from 'react';
import imgPrepare from "../assets/images/prepare.png";
import imgTrack from "../assets/images/track.png";
import imgConnect from "../assets/images/connect.png";
import { useOverviewContext } from '../context/OverviewContext';
import "../assets/css/PopupSlider.css";

const PopupSlider: React.FC = () => {
  const { userRoleVal } = useOverviewContext();
  const [showPopup, setShowPopup] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loadedImages, setLoadedImages] = useState<{ [key: string]: boolean }>({});

  const slides = [
    {
      image: imgPrepare,
      title: "Prepare",
      content:
        "Get ready for a successful year! Access school forms and documents, learn what it takes to be a learning coach, explore the online school, and get your email setup.",
    },
    {
      image: imgTrack,
      title: "Track",
      content:
        "You provide the basics, we provide the rest. See what learning materials you might need and what you can expect to arrive at your door! ",
    },
    {
      image: imgConnect,
      title: "Connect",
      content:
        "Learn about your local Learning Coach Community! You’ll be able to chat, share tips, and more in a safe, supportive space. You’ll also learn how your student can stay social in the K12 Zone.",
    },
  ];

  // LocalStorage Logic
  const localStorageKey = `popupShown_${userRoleVal}`;

  useEffect(() => {
    const popupSeen = localStorage.getItem(localStorageKey);
    if (!popupSeen) {
      setShowPopup(true);
    }
  }, []);

  useEffect(() => {
    // Preload images
    const preloadImages = async () => {
      const promises = slides.map(slide => {
        return new Promise<void>((resolve) => {
          const img = new Image();
          img.src = slide.image;
          img.onload = () => {
            setLoadedImages(prev => ({ ...prev, [slide.image]: true }));
            resolve();
          };
        });
      });

      await Promise.all(promises);
    };

    preloadImages();
  }, []);

  const nextSlide = () => {
    if (currentSlide < slides.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      closePopup();
    }
  };

  const closePopup = () => {
    // Set flag in localStorage - Not Show Popup
    localStorage.setItem(localStorageKey, "true");
    setShowPopup(false);
  };

  if (!showPopup) return null;

  return (
    <div id="initial-popup" className="overlay show">
      <div className="popup">
        <div className="slide">
          <img
            src={slides[currentSlide].image}
            alt="Slide Image"
            className="slide-image"
            style={{ visibility: loadedImages[slides[currentSlide].image] ? "visible" : "hidden" }}
          />
          <h2>{slides[currentSlide].title}</h2>
          <button className="close" onClick={closePopup}>&times;</button>
          <div className="content">{slides[currentSlide].content}</div>
          <ol className="slide-indicators">
            {slides.map((_, index) => (
              <li key={index} className={currentSlide === index ? "active" : ""}></li>
            ))}
          </ol>
          {currentSlide < slides.length - 1 ? (
            <button className="button next" onClick={nextSlide}>Next</button>
          ) : (
            <button className="button next" onClick={closePopup}>Get Started</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PopupSlider;
